/**
 * Shortens a given string to a specified number of words
 *
 * @param str - The input string to be shortened.
 * @param num - The maximum number of words to keep in the shortened string.
 * @returns The shortened string, or the original string if it has fewer than the specified number of words.
 */
// TODO: what is this ?
export function shortenString(str: string, num: number): string {
  const words = str.split(' ');
  if (words.length <= num) {
    return str;
  }
  return words.slice(0, num).join(' ') + '...';
}
